<template>
  <section class="subscribe-section py-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white scroll-animate">
    <div class="container mx-auto px-4">
      <div class="max-w-3xl mx-auto text-center">
        <h2 class="text-3xl md:text-4xl font-bold mb-6">快速报装</h2>
        <p class="text-xl mb-8">获取最新的产品信息、技术资讯和行业洞察</p>
        <form class="flex flex-col md:flex-row gap-4 max-w-xl mx-auto" @submit.prevent="handleSubscribe">
          <input v-model="phone" placeholder="请输入您的手机号码" type="tel" class="flex-1 px-4 py-3 rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300" :disabled="loading" />
          <el-button type="primary" size="medium" :loading="loading" @click="handleSubscribe" style="background-color: #409EFF; border-color: #409EFF;">
            {{ loading ? '提交中...' : '报装' }}
          </el-button>
        </form>
        <p class="text-sm mt-4 text-blue-200">我们尊重您的隐私，不会向第三方分享您的信息</p>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SubscribeSection',
  data() {
    return {
      phone: '',
      loading: false
    };
  },
  methods: {
    async handleSubscribe() {
      if (!this.phone) {
        this.$message.warning('请输入您的手机号码');
        return;
      }
      // 正则验证手机号码格式
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.warning('请输入正确的手机号码');
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post('/node/api/v1/public/submitPhoneNumber', {
          phone: this.phone
        });

        if (response.data.success) {
          this.$message.success('您的报装已成功提交！48小时内我们客户经理会联系您。感谢您的选择！');
          this.phone = '';
          console.log('提交成功的数据:', response.data.data);
        } else {
          this.$message.error(response.data.message || '报装失败，请稍后重试');
        }
      } catch (error) {
        console.error('报装失败:', error);
        this.$message.error('报装失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.subscribe-section {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}
</style>
